




















































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { SysKBContentDetailsModule } from '@/store/modules/sysKBContentDetails';
import Alert from '@/components/Shared/Alert.vue';
import KBStatusBadge from '@/components/KnowledgeBase/KBStatusBadge.vue';
import KBVisibilityBadge from '@/components/KnowledgeBase/KBVisibilityBadge.vue';
import MarkdownEditor from '@/components/KnowledgeBase/MarkdownEditor.vue';
import MarkdownRenderer from '@/components/KnowledgeBase/MarkdownRenderer.vue';
import ArticleTableOfContents from '@/components/KnowledgeBase/ArticleTableOfContents.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import PageNames from '@/router/PageNames';
import KBContentDto from '@/models/KnowledgeBase/KBContentDto';
import UpdateKBContentDraftRequest from '@/models/KnowledgeBase/UpdateKBContentDraftRequest';
import PublishContentRequest from '@/models/KnowledgeBase/PublishContentRequest';
import RevertContentDraftRequest from '@/models/KnowledgeBase/RevertContentDraftRequest';
import { countWords, estimateReadingTime } from '@/lib/markdownUtils';
import ListUtils from '@/lib/listUtils';

@Component({
  name: 'SysAdminKBContent',
  components: {
    Alert,
    KBStatusBadge,
    KBVisibilityBadge,
    MarkdownEditor,
    MarkdownRenderer,
    ArticleTableOfContents
  }
})
export default class extends GiganautVue {
  private editorTab = 0;
  private saving = false;
  private publishing = false;
  private deleting = false;
  private publishDialog = false;
  private deleteDialog = false;
  private publishMessage = '';
  private permanentDelete = false;

  // v4: Version History & Revert
  private historyDialog = false;
  private revertDialog = false;
  private loadingHistory = false;
  private versions: any[] = [];
  private revertToVersion = 0;
  private reverting = false;

  // Edit fields
  private editTitle = '';
  private editSlug = '';
  private editVisibility = 1;
  private editContent = '';

  get loading(): boolean {
    return SysKBContentDetailsModule.loading;
  }

  get content(): KBContentDto | null {
    return SysKBContentDetailsModule.content;
  }

  get visibilityOptions() {
    return ListUtils.contentVisibilityOptions();
  }

  get canPublish(): boolean {
    return this.content?.draft != null;
  }

  get wordCount(): number {
    return countWords(this.editContent);
  }

  get readingTime(): number {
    return estimateReadingTime(this.editContent);
  }

  created() {
    this.loadContent();
  }

  async loadContent() {
    const contentId = this.$route.params.contentid;
    await SysKBContentDetailsModule.getContent(contentId);
    this.initializeEditFields();
  }

  initializeEditFields() {
    if (!this.content) return;

    // Prefer draft over published for editing
    if (this.content.draft) {
      this.editTitle = this.content.draft.title;
      this.editSlug = this.content.draft.slug;
      this.editContent = this.content.draft.content;
    } else if (this.content.published) {
      this.editTitle = this.content.published.title;
      this.editSlug = this.content.published.slug;
      this.editContent = this.content.published.content;
    }

    this.editVisibility = this.content.visibility;
  }

  async saveDraft() {
    console.log('saveDraft called');
    if (!this.content) {
      console.log('No content, returning');
      return;
    }

    console.log('Current edit values:', {
      title: this.editTitle,
      slug: this.editSlug,
      content: this.editContent?.substring(0, 100), // First 100 chars
      visibility: this.editVisibility
    });

    this.saving = true;
    try {
      const request = new UpdateKBContentDraftRequest();
      request.title = this.editTitle;
      request.slug = this.editSlug;
      request.content = this.editContent;
      request.visibility = this.editVisibility;

      console.log('Sending request:', request);

      await SysKBContentDetailsModule.updateContentDraft({
        contentId: this.content.id,
        request
      });

      console.log('Save successful');
      // Note: Don't call initializeEditFields() here - the store will update
      // and the user is still editing, so we shouldn't reset their fields
    } catch (error) {
      console.error('Save failed:', error);
    } finally {
      this.saving = false;
    }
  }

  async publish() {
    if (!this.content) return;

    this.publishing = true;
    try {
      const request = new PublishContentRequest();
      request.changeSummary = this.publishMessage;

      await SysKBContentDetailsModule.publishContent({
        contentId: this.content.id,
        request
      });

      this.publishDialog = false;
      this.publishMessage = '';
      this.initializeEditFields();
    } finally {
      this.publishing = false;
    }
  }

  async deleteContent() {
    if (!this.content) return;

    this.deleting = true;
    try {
      await SysKBContentDetailsModule.deleteContent({
        contentId: this.content.id,
        permanently: this.permanentDelete
      });

      this.goBack();
    } finally {
      this.deleting = false;
    }
  }

  async viewHistory() {
    if (!this.content) return;

    this.historyDialog = true;
    this.loadingHistory = true;

    try {
      // Fetch version history from API
      const response = await this.$ajax.get(`/api/v1/kb/content/${this.content.id}/versions`);
      this.versions = response.data.items || [];
    } catch (error) {
      console.error('Failed to load version history:', error);
      this.versions = [];
    } finally {
      this.loadingHistory = false;
    }
  }

  confirmRevert(version: number) {
    this.revertToVersion = version;
    this.revertDialog = true;
  }

  async revertDraft() {
    if (!this.content) return;

    this.reverting = true;
    try {
      const request = new RevertContentDraftRequest();
      request.version = this.revertToVersion;

      await SysKBContentDetailsModule.revertContentDraft({
        contentId: this.content.id,
        request
      });

      this.revertDialog = false;
      this.historyDialog = false;
      this.initializeEditFields();
    } catch (error) {
      console.error('Failed to revert draft:', error);
    } finally {
      this.reverting = false;
    }
  }

  goBack() {
    this.$router.push({ name: PageNames.SysAdminKnowledgeBase });
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
